import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Phone } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card, CardBody } from '../components/ui/Card';
export function FleetCars() {
  // Generate 20 cars
  const cars = Array.from({
    length: 20
  }).map((_, i) => {
    const models = ['Honda Odyssey', 'Toyota Camry', 'Chrysler 200', 'Hyundai Sonata', 'Kia Optima', 'Ford Fusion', 'Chevy Malibu', 'Nissan Altima', 'Subaru Legacy', 'Mazda 6'];
    const years = ['2022', '2023', '2024', '2025'];
    const prices = [35, 40, 45, 50, 55, 60, 65];
    const model = models[i % models.length];
    const year = years[i % years.length];
    const price = prices[i % prices.length];
    // Use varied unsplash IDs for cars
    const imageIds = ['1549317661-bd32c8ce0afa', '1583121274602-3e2820c69888', '1494976388531-d1058494cdd8', '1552519507-da3b142c6e3d', '1550355291-bbee04aed9c2', '1503376780353-7e6692767b70'];
    const imageId = imageIds[i % imageIds.length];
    return {
      id: i,
      name: `${model} Accessible`,
      year,
      price: `$${price}/hr`,
      description: `Fully modified ${model} featuring specialized hand controls, transfer seats, and easy wheelchair access for comfortable daily transport.`,
      image: `https://images.unsplash.com/photo-${imageId}?w=600&h=400&fit=crop&q=80&sig=${i}` // sig added to prevent browser caching same image
    };
  });
  return <div className="bg-warm-50 min-h-screen pb-20" data-id="element-434">
      {/* Page Header */}
      <div className="bg-white py-12 border-b border-warm-200 mb-12" data-id="element-435">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-436">
          <Link to="/fleet" className="inline-flex items-center text-primary-600 hover:text-primary-800 font-medium mb-6 transition-colors" data-id="element-437">
            <ArrowLeft className="w-4 h-4 mr-2" data-id="element-438" /> Back to Fleet Overview
          </Link>
          <h1 className="text-4xl font-extrabold text-black mb-4" data-id="element-439">
            Wheelchair Accessible Cars
          </h1>
          <p className="text-lg text-warm-600 max-w-3xl" data-id="element-440">
            Browse our complete inventory of modified sedans and compact cars
            designed for accessibility and comfort.
          </p>
        </div>
      </div>

      {/* Grid */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-441">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-442">
          {cars.map(vehicle => <Card key={vehicle.id} className="rounded-2xl shadow-md overflow-hidden hover:shadow-xl transition-shadow duration-300 border-none bg-white flex flex-col h-full" data-id="element-443">
              <img src={vehicle.image} alt={vehicle.name} className="w-full h-48 object-cover" data-id="element-444" />
              <CardBody className="p-6 flex flex-col flex-grow" data-id="element-445">
                <div className="flex justify-between items-start mb-2" data-id="element-446">
                  <h3 className="text-xl font-bold text-black leading-tight" data-id="element-447">
                    {vehicle.name}
                  </h3>
                  <span className="bg-warm-100 text-warm-800 text-xs font-bold px-2 py-1 rounded" data-id="element-448">
                    {vehicle.year}
                  </span>
                </div>
                <p className="text-primary-600 font-bold text-lg mb-3" data-id="element-449">
                  {vehicle.price}
                </p>
                <p className="text-warm-600 text-sm mb-6 flex-grow" data-id="element-450">
                  {vehicle.description}
                </p>
                <div className="flex gap-3 mt-auto items-stretch" data-id="element-451">
                  <Link to="/booking" className="flex-1 flex" data-id="element-452">
                    <Button variant="primary" size="sm" className="w-full h-full" data-id="element-453">
                      Call
                    </Button>
                  </Link>
                  <Link to="/booking" className="flex-1 flex" data-id="element-454">
                    <Button variant="outline" size="sm" className="w-full h-full border-2" data-id="element-455">
                      Hire Now
                    </Button>
                  </Link>
                </div>
              </CardBody>
            </Card>)}
        </div>

        {/* Bottom CTA */}
        <div className="mt-20 bg-black rounded-3xl p-10 text-center text-white shadow-2xl" data-id="element-456">
          <h2 className="text-3xl font-bold mb-4" data-id="element-457">
            Need help choosing the right car?
          </h2>
          <p className="text-warm-400 mb-8 max-w-2xl mx-auto" data-id="element-458">
            Our mobility specialists are available 24/7 to help you find the
            perfect vehicle for your specific needs.
          </p>
          <a href="tel:5551234567" data-id="element-459">
            <Button size="lg" className="bg-primary-600 hover:bg-primary-700 text-white border-none" data-id="element-460">
              <Phone className="w-5 h-5 mr-2" data-id="element-461" /> Call (555) 123-4567
            </Button>
          </a>
        </div>
      </div>
    </div>;
}